import { Empty } from 'antd';
import styled from 'styled-components';

const EmptyStyled = styled(Empty)`
	margin: ${props => (props.margin ? props.margin : props.theme.empty.margin)};
`;

export default EmptyStyled;
